import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-md-10 ml-sm-auto pt-3 px-4 products" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12 text-start" }
const _hoisted_4 = {
  key: 0,
  class: "small"
}
const _hoisted_5 = {
  key: 1,
  class: "small"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = {
  key: 0,
  class: "text-start mt-3"
}
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CartNav = _resolveComponent("CartNav")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_FaultyProductItem = _resolveComponent("FaultyProductItem")!
  const _component_ProductItem = _resolveComponent("ProductItem")!
  const _component_element = _resolveComponent("element")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.cartStore.cart.length > 0)
      ? (_openBlock(), _createBlock(_component_CartNav, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "bold d-inline-block" }, "Products", -1)),
        (!_ctx.isLoading && _ctx.productsStore.products)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (" + _toDisplayString(_ctx.productsStore.products.length) + ")", 1))
          : _createCommentVNode("", true),
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Loading..."))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_Loading, { isLoading: _ctx.isLoading }, null, 8, ["isLoading"]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (!_ctx.productsStore.products)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[1] || (_cache[1] = [
              _createElementVNode("span", { style: {"font-weight":"bold"} }, "Notice: Temporary Product Loading Issues", -1),
              _createElementVNode("br", null, null, -1),
              _createElementVNode("br", null, null, -1),
              _createTextVNode(" We are currently experiencing some issues with loading products. To resolve this, please try the following steps:"),
              _createElementVNode("br", null, null, -1),
              _createElementVNode("br", null, null, -1),
              _createTextVNode(" Log out of your account and then log back in. "),
              _createElementVNode("br", null, null, -1),
              _createElementVNode("br", null, null, -1),
              _createElementVNode("span", { class: "ms-3" }, "1. Refresh your webbrowser after each step in the process.", -1),
              _createElementVNode("br", null, null, -1),
              _createElementVNode("span", { class: "ms-3" }, "2. These actions often helprestore visibility of the products.", -1),
              _createElementVNode("br", null, null, -1),
              _createElementVNode("br", null, null, -1),
              _createTextVNode("If the issue persists after trying these steps, please contact your Supply account manager at BioGaia for further assistance. Thank you for your understanding and cooperation. ")
            ])))
          : _createCommentVNode("", true)
      ]),
      (
          _ctx.productsStore.hasAnyProducts() || _ctx.productsStore.hasAnyFaultyProducts()
        )
        ? (_openBlock(), _createBlock(_component_element, { key: 0 }, {
            default: _withCtx(() => [
              (_ctx.productsStore.hasAnyFaultyProducts())
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_FaultyProductItem, {
                      productData: _ctx.productsStore.faultyProducts
                    }, null, 8, ["productData"])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsStore.products, (product, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createVNode(_component_ProductItem, { productData: product }, null, 8, ["productData"])
                ]))
              }), 128))
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_element, { key: 1 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.isLoading ? "" : _ctx.mainError), 1)
            ]),
            _: 1
          }))
    ])
  ]))
}